import request from '@/utils/request'

// 蛋糕叔叔-订单确认信息
export function getUncleCakeOrderConfirmInfo(params) {
  return request({
    url: '/plat-web/uncleCake/orderConfirm',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 蛋糕叔叔-去支付
export function uncleCakeToPay(params) {
  return request({
    url: '/plat-web/uncleCake/toCashier',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 蛋糕叔叔-获取充值说明
export function getUncleCakeCustomDetails() {
  return request({
    url: '/plat-web/customDetails/getByType?requestType=19',
    method: 'get',
    isPlatWeb: true
  })
}

// 蛋糕叔叔-订单详情
export function getUncleCakeOrderDetail(params) {
  return request({
    url: '/plat-web/uncleCake/orderDetail',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 蛋糕叔叔-查看订单链接
export function getUncleCakeOrderListUrl(params) {
  return request({
    url: '/plat-web/uncleCake/h5InvokeLoginOrderList',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}
